import { h } from "./../../utils/createElement";
import { __assign, __extends } from "tslib";
import * as React from 'react';
import { MouseAction } from './interface';
import { consumeTheme } from '../../utils/theme';
var Navigation = (function (_super) {
    __extends(Navigation, _super);
    function Navigation() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.themedRender = function (classNames) {
            var _a = _this.props, navCount = _a.navCount, currentIndex = _a.currentIndex, onNavMouseAction = _a.onNavMouseAction, prefixCls = _a.prefixCls, className = _a.className, navColor = _a.navColor, navActiveColor = _a.navActiveColor, navigationDotsStyle = _a.navigationDotsStyle, navigationDotsClassName = _a.navigationDotsClassName, style = _a.style;
            var res = [];
            var _loop_1 = function (index) {
                var isCurrent = index === currentIndex % navCount || (currentIndex === -1 && index === navCount - 1);
                var itemClassName = classNames(prefixCls + "-item");
                res.push(h("li", { key: "key" + index, className: itemClassName, onClick: function () { return onNavMouseAction === null || onNavMouseAction === void 0 ? void 0 : onNavMouseAction(MouseAction.CLICK, index); }, onMouseEnter: function () { return onNavMouseAction === null || onNavMouseAction === void 0 ? void 0 : onNavMouseAction(MouseAction.ENTER, index); }, style: {
                        backgroundColor: isCurrent ? navActiveColor : navColor,
                    } }));
            };
            for (var index = 0; index < navCount; index++) {
                _loop_1(index);
            }
            var cls = classNames(prefixCls, className);
            var navDotsCls = classNames(prefixCls, navigationDotsClassName, prefixCls + "-dots");
            return (h("div", { className: cls, style: __assign({}, style) },
                _this.renderArrow(classNames),
                h("ul", { className: navDotsCls, style: __assign({}, navigationDotsStyle) }, res)));
        };
        return _this;
    }
    Navigation.prototype.render = function () {
        return consumeTheme(this.themedRender);
    };
    Navigation.prototype.renderArrow = function (classNames) {
        var _a = this.props, prefixCls = _a.prefixCls, arrowStyle = _a.arrowStyle, arrowClassName = _a.arrowClassName, renderLeftArrow = _a.renderLeftArrow, renderRightArrow = _a.renderRightArrow, onClickArrow = _a.onClickArrow;
        var arrowCls = classNames(prefixCls, arrowClassName, prefixCls + "-arrow");
        return (h("div", { className: arrowCls, style: __assign({}, arrowStyle) },
            renderLeftArrow && (h("div", { className: arrowCls + "-left", onClick: function () { return onClickArrow === null || onClickArrow === void 0 ? void 0 : onClickArrow('left'); } })),
            renderRightArrow && (h("div", { className: arrowCls + "-right", onClick: function () { return onClickArrow === null || onClickArrow === void 0 ? void 0 : onClickArrow('right'); } }))));
    };
    return Navigation;
}(React.Component));
export default Navigation;
Navigation.defaultProps = {
    prefixCls: 'dui-swiper-navigation',
    navigationDotsStyle: {
        height: '12px',
        width: '14px',
        margin: '8px',
    },
    arrowStyle: {},
    navColor: 'rgba(0, 0, 0, 0.24)',
    navActiveColor: '#fff',
};
